export default "__VITE_ASSET__JhfHcdDq__"